<template>
  <header
    :class="['header', { 'mobile-header': isMobile }]"
  >
    <b-modal
      ref="exchange-rate"
      ignore-enforce-focus-selector=".header"
      hide-footer
      hide-header
      modal-class="padding-top_modal-list"
      dialog-class="header-app__exchange-rate-modal"
      body-class="modal_body"
      content-class="modal_content"
      id="exchange-rate"
    >
      <exchange-rate-list
        :currency-info="currencies"
        @close="isExchangeRateActive = false"
      />
    </b-modal>
    <logo class="header__logo" color="white"/>
    <b-dropdown
      id="profile-dropdown"
      v-if="isMobile"
      :text="$t('headerApp.language.short')"
      offset="-100"
      class="header-app__navbar-button-lang_navbar header-app__navbar-button-lang_dropdown"
      menu-class="menu-custom header-app__navbar-button-lang_menu"
      toggle-class="header-app__navbar-button-lang_toggle"
      type="button"
    >
      <b-dropdown-item
        :active="currentLanguage === 'ru'"
        link-class="header__dropdown-item_lang"
        @click="setLocale('ru')"
      >
        {{ $t('cardForm.language.russian')}}
      </b-dropdown-item>
      <b-dropdown-item
        :active="currentLanguage==='en'"
        link-class="header__dropdown-item_lang"
        @click="setLocale('en')"
      >
        {{ $t('cardForm.language.english')}}
      </b-dropdown-item>
    </b-dropdown> <!-- Language selection -->
    <burger-button
      v-if="isMobile"
      @click="showSideBar = !showSideBar"
      class="burger-button"
    /> <!-- Mobile burger button -->
    <b-nav v-if="!isMobile" class="header__navbar">
      <b-nav-item link-classes="navbar__item">
        <router-link
          active-class="navbar-link_active"
          class="navbar-link"
          :to="linkToEvents()"
        >
          <font-awesome-icon
            icon="calendar-alt"
            class="link-icon"
          />
          {{ $t('headerApp.events') }}
        </router-link>
      </b-nav-item>
      <b-nav-item link-classes="navbar__item">
        <router-link
          active-class="navbar-link_active"
          class="navbar-link"
          to="/people"
        >
          <b-icon-person class="link-icon"/>
          {{ $t('headerApp.people') }}
        </router-link>
      </b-nav-item>
      <b-nav-item link-classes="navbar__item">
        <a
          @click="toggleExchangeRate"
          href="#"
          class="navbar-link"
          :class="{active: isExchangeRateActive}"
        >
          <timeline
            class="link-icon exchange-rate-icon"
            :class="{ 'exchange-rate_active': isExchangeRateActive }"
          />
          {{ $t('CP.exchangeRates') }}
        </a>
      </b-nav-item>
      <b-nav-item link-classes="navbar__item">
        <b-dropdown
          :text="$t('headerApp.language.short')"
          class="header-app__navbar-button-lang_navbar header-app__navbar-button-lang_dropdown"
          menu-class="menu-custom header-app__navbar-button-lang_menu"
          toggle-class="header-app__navbar-button-lang_toggle"
          type="button"
        >
          <b-dropdown-item
            :active="currentLanguage === 'ru'"
            link-class="header__dropdown-item_lang"
            @click="setLocale('ru')"
          >
            {{ $t('cardForm.language.russian')}}
          </b-dropdown-item>
          <b-dropdown-item
            :active="currentLanguage==='en'"
            link-class="header__dropdown-item_lang"
            @click="setLocale('en')"
          >
            {{ $t('cardForm.language.english')}}
          </b-dropdown-item>
        </b-dropdown>
      </b-nav-item>
      <b-nav-item
        class="header__dropdown__right">
        <b-dropdown
          id="dropdown-1"
          class="dropdown-btn invertColor"
          :toggle-class="['dropdownMenu', 'invertColor', 'userDropdownToggle',
              {show: showSettingsDropdown, show_transition: showSettingsDropdown}]"
          variant="outline"
          :offset="-40"
          menu-class="menu-custom userDropdownMenu"
          no-caret
        >
          <template
            v-slot:button-content>
            <div
              class="dropdownMenu invertColor"
              @click="showSettingsDropdown = !showSettingsDropdown"
            >
                <span
                  class="username"
                >{{ fullName || 'username' }}
              </span>
              <profile-image
                :src="avatarUrl"
                :user="{ full_name: fullName }"
                v-if="avatarUrl"
                width="25px"
                height="25px"/>
              <font-awesome-icon
                icon="chevron-down"
                class="chevron-icon_profile"
              />
            </div>
          </template>
          <b-dropdown-item
            @click="$bvModal.show('settings')"
            link-class="header__dropdown-item"
            href="#"
          >
            {{ $t('headerApp.settings') }}
          </b-dropdown-item>
          <b-dropdown-item
            link-class="header__dropdown-item header__dropdown-item_share"
            href="#"
          >
            <b-dropdown
              id="dropdown-2"
              class="dropdown-btn invertColor share"
              :text="$t('headerApp.tellAFriend')"
              :toggle-class="['dropdownMenu', 'share_toggle',
              {show: showSettingsDropdown, show_transition: showSettingsDropdown}]"
              variant="outline"
              :offset="40"
              dropleft
              menu-class="menu-custom share_menu"
              no-caret
            >
              <b-dropdown-item
                link-class="header__dropdown-item"
                @click="shareVK"
              >
                VK
              </b-dropdown-item>
              <b-dropdown-item
                link-class="header__dropdown-item"
                href="#"
                @click="shareFacebook"
              >
                Facebook
              </b-dropdown-item>
              <b-dropdown-item
                link-class="header__dropdown-item"
                href="#"
                @click="shareTwitter"
              >
                Twitter
              </b-dropdown-item>
            </b-dropdown>
          </b-dropdown-item>
          <b-dropdown-item
            @click="showProductTour"
            link-class="header__dropdown-item"
            v-if="isProductTourAvailable"
          >
            {{ $t('headerApp.productTour') }}
          </b-dropdown-item>
<!--          <b-dropdown-item-->
<!--            to="/faq"-->
<!--            link-class="header__dropdown-item"-->
<!--          >-->
<!--            {{ $t('headerApp.faq') }}-->
<!--          </b-dropdown-item>-->
          <b-dropdown-item
            :href="`mailto:${basicInfo.supportServiceEmail}`"
            link-class="header__dropdown-item"
            @click.stop
            target="_blank"
          >
            {{ $t('headerApp.supportService') }}
          </b-dropdown-item>
          <b-dropdown-item
            link-class="header__dropdown-item"
            @click="logout"
            href="#"
          >
            {{ $t('headerApp.exit') }}
          </b-dropdown-item>
        </b-dropdown>
      </b-nav-item>
    </b-nav> <!-- Desktop navigation -->
    <b-sidebar
      v-if="isMobile"
      no-header
      body-class="mobile-sidebar-menu_body"
      class="mobile-sidebar-menu"
      v-model="showSideBar"
      right
      backdrop
      shadow
    >
      <header class="sidebar-header">
        <img src="../../assets/img/whitelogo.svg" alt="">
      </header>
      <b-nav v-if="isMobile" class="header__navbar">
        <b-nav-item
          class="header__dropdown__right">
          <b-dropdown
            class="dropdown-btn invertColor"
            :toggle-class="['dropdownMenu', 'invertColor', 'dropdownMenu_profile',
              {show: showSettingsDropdown, show_transition: showSettingsDropdown}]"
            variant="outline"
            :offset="-40"
            menu-class="menu-custom"
            no-caret
          >
            <template
              v-slot:button-content>
              <div
                class="dropdownMenu user-settings"
                @click="showSettingsDropdown = !showSettingsDropdown"
              >
                <span
                  class="username"
                >
                  {{ fullName || 'Username' }}
                </span>
                <profile-image
                  :src="avatarUrl"
                  :user="{ full_name: fullName }"
                  v-if="avatarUrl"
                  width="25px"
                  height="25px"/>
                <font-awesome-icon icon="chevron-down" class="chevron-icon_profile"/>
              </div>
            </template>
            <b-dropdown-item
              @click="() => {
                $bvModal.show('settings');
                showSideBar = !showSideBar;
              }"
              link-class="header__dropdown-item"
              href="#">
              {{ $t('headerApp.settings') }}
            </b-dropdown-item>
            <b-dropdown-item
              link-class="header__dropdown-item"
              @click="logout"
              href="#">
              {{ $t('headerApp.exit') }}
            </b-dropdown-item>
          </b-dropdown>
        </b-nav-item>
        <b-nav-item link-classes="navbar__item">
          <b-dropdown
            id="dropdown-3"
            class="dropdown-btn invertColor share"
            :toggle-class="['dropdownMenu', 'share_toggle',
              {show: showSettingsDropdown, show_transition: showSettingsDropdown}]"
            variant="outline"
            :offset="-40"
            menu-class="menu-custom share_menu"
            no-caret
          >
            <template
              v-slot:button-content>
              <div
                class="dropdownMenu user-settings navbar-link"
                @click="showSettingsDropdown = !showSettingsDropdown"
              >
                {{ $t('headerApp.tellAFriend') }}
              </div>
            </template>
            <b-dropdown-item
              link-class="header__dropdown-item"
              @click="shareVK"
            >
              VK
            </b-dropdown-item>
            <b-dropdown-item
              link-class="header__dropdown-item"
              href="#"
              @click="shareFacebook"
            >
              Facebook
            </b-dropdown-item>
            <b-dropdown-item
              link-class="header__dropdown-item"
              href="#"
              @click="shareTwitter"
            >
              Twitter
            </b-dropdown-item>
          </b-dropdown>
        </b-nav-item>
        <b-nav-item link-classes="navbar__item">
          <router-link
            active-class="navbar-link_active"
            class="navbar-link"
            to="/events"
          >
            <font-awesome-icon icon="calendar-alt" class="link-icon"/>
            {{ $t('headerApp.events') }}
          </router-link>
        </b-nav-item>
        <b-nav-item link-classes="navbar__item">
          <router-link
            active-class="navbar-link_active"
            class="navbar-link"
            to="/people"
          >
            <b-icon icon="person-fill" class="link-icon"/>
            {{ $t('headerApp.people') }}
          </router-link>
        </b-nav-item>
        <b-nav-item link-classes="navbar__item">
          <button
            @click="toggleExchangeRate"
            class="exchange-rate-button navbar-link"
            :class="{active: isExchangeRateActive}"
          >
            <timeline
              class="link-icon exchange-rate-icon"
              :class="{ 'exchange-rate_active': isExchangeRateActive }"
            />
            {{ $t('CP.exchangeRates') }}
          </button>
        </b-nav-item>
        <b-nav-item
          link-classes="navbar__item"
          :href="`mailto:${basicInfo.supportServiceEmail}`"
          @click.stop
          target="_blank"
        >
          <span
            class="navbar-link"
          >
            <b-icon icon="question-circle-fill" class="link-icon" />
            {{ $t('headerApp.supportService') }}
          </span>
        </b-nav-item>
      </b-nav>
    </b-sidebar> <!-- Mobile navigation sidebar selection -->
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Timeline from 'vue-material-design-icons/ChartTimelineVariant';
import { AUTH_LOGOUT } from '@/store/auth/types';
import { CLEAR_TOUR_STATES } from '@/store/tour/types';
import { SET_LANGUAGE } from '@/store/app/types';
import { Share } from '@/utils/Share';
import { productTours } from '@/plugins/shepherd';
import Logo from '../../components/Logo/Logo';
import BurgerButton from '../../components/BurgerButton/BurgerButton';
import ProfileImage from '../../components/ProfileImage/ProfileImage';
import ExchangeRateList from '../../components/ExchangeRateList/ExchangeRateList';

export default {
  name: 'HeaderApp',
  components: {
    ExchangeRateList,
    ProfileImage,
    BurgerButton,
    Logo,
    Timeline,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSettingsDropdown: false,
      isExchangeRateActive: false,
      showSideBar: false,
      isDropdown2Visible: false,
      breakpointLg: window.matchMedia('(min-width: 1025px)'),
      isProductTourAvailable: false,
    };
  },
  computed: {
    ...mapGetters(['getProfile', 'basicInfo']),
    ...mapState({
      currentLanguage: (state) => state.app.currentLanguage,
      fullName: (state) => state.user.user.full_name,
      avatarUrl: (state) => state.user.user.avatar_url,
      event: (state) => state.events.event,
      currencies: (state) => state.currency,
    }),
  },
  mounted() {
    this.$root.$on('bv::dropdown::show', (bvEvent) => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on('bv::dropdown::hide', (bvEvent) => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    this.checkIfProductTourAvailable();
    window.addEventListener('resize', this.checkIfProductTourAvailable);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfProductTourAvailable);
  },
  methods: {
    checkIfProductTourAvailable() {
      if (this.breakpointLg.matches) {
        this.isProductTourAvailable = true;
      } else {
        this.isProductTourAvailable = false;
      }
    },
    showProductTour() {
      this.$store.dispatch(CLEAR_TOUR_STATES);
      if (this.$route.name !== 'TransactionsPage') {
        this.$router.push('/events');
      } else {
        productTours[this.$i18n.locale].mainTour.start();
      }
    },
    shareVK() {
      Share.vkontakte(
        'https://repayapp.com/',
        this.$t('CP.offerRepay'),
        'https://repayapp.com/app/app/images/repay_icon_512.png',
        this.$t('CP.offerRepay'),
      );
    },
    shareFacebook() {
      Share.facebook(
        'https://repayapp.com/',
        this.$t('CP.offerRepay'),
        'https://repayapp.com/app/app/images/repay_icon_512.png',
        this.$t('CP.offerRepay'),
      );
    },
    shareTwitter() {
      Share.twitter(
        'https://repayapp.com/',
        this.$t('CP.offerRepay'),
      );
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$moment.locale(locale);
      this.$store.dispatch(SET_LANGUAGE, locale);
    },
    toggleExchangeRate() {
      this.$refs['exchange-rate'].toggle();
      this.showSideBar = !this.showSideBar;
      this.isExchangeRateActive = !this.isExchangeRateActive;
    },
    oldVersion() {
      window.open('https://old.repayapp.com/app/');
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT);
    },
    linkToEvents() {
      let link = '/events';
      if (this.$route.params.id) {
        link += `/${this.$route.params.id}`;
      }
      if (this.$route.path.indexOf('transactions') !== -1) {
        link += '/transactions';
      } else if (this.$route.path.indexOf('my-share') !== -1) {
        link += '/my-share';
      } else if (this.$route.path.indexOf('debts') !== -1) {
        link += '/debts';
      }
      return link;
    },
  },
};
</script>

<style lang="scss" scoped>
  .header {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    background: var(--text-main-color);
    height: 45px;
    min-height: 45px;
    min-width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    font-size: 1.5rem;
    font-weight: 400;
  }
  .mobile-header {
    z-index: 500;
  }
  /*body:not([class~="modal-open"]) .HeaderModals {
    position: relative;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    animation: HeaderModals-out .3s;
  }
  body[class~="modal-open"] .HeaderModals {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    animation: HeaderModals-in .3s;
  }
  @keyframes HeaderModals-out {
    0% {
      position: fixed;
      opacity: 0;
      transform: translateY(0);
    }
    100% {
      position: fixed;
      opacity: 1;
      transform: translateY(-45px);
    }
  }
  @keyframes HeaderModals-in {
    0% {
      top: -45px;
      opacity: 0;
      transform: translateY(-45px);
    }
    100% {
      top: 0;
      opacity: 1;
      transform: translateY(0);
    }
  }*/

  .chevron-icon {
    color: #FFFFFF;
  }

  .header__logo {
    margin: 0 auto 0 32px;
  }

  .header__navbar {
    display: flex;
    align-items: center;
  }

  .header__dropdown {
    margin: 0 20px 0 30px;
    color: var(--text-main-color);
  }

  .navbar__item {
    font-size: 14px;
    padding: 0;
  }

  .navbar-link {
    color: #A9B1E2;
    text-decoration: none;
    padding: 8px 16px;
    display: flex;
    align-content: center;
  }

  .navbar-link_active {
    color: #FFFFFF;
  }

  .navbar-button {
    color: #A9B1E2;
    padding: 8px 16px;
    background: var(--text-main-color);
    border: none;
    outline: none;
    &:active, &:focus {
      color: #FFFFFF;
    }
  }

  .link-icon {
    margin-right: 6px;
    opacity: 0.6;
    width: 20px;
    height: 20px;
  }
  .material-design-icon.exchange-rate-icon {
    height: 20px;
    width: 20px;
  }
  .material-design-icon.exchange-rate-icon > .material-design-icon__svg {
    height: 20px;
    width: 20px;
  }
  .exchange-rate_active {
    opacity: 1;
  }
  .navbar-link_active .link-icon {
    opacity: 1;
  }
  .exchange-rate-button {
    background: transparent;
    padding: 8px 16px;
    border: none;
    outline: none;
    color: #A9B1E2;
    &.active {
      color: #FFFFFF;
    }
  }
  .burger-button {
    margin-right: 13px;
  }
  .show_translate {
    position: absolute;
    transform: translate3d(-20px, 37px, 0px);
    top: 0;
    left: 0;
    will-change: transform;
  }
  .chevron-icon_profile {
    font-size: 12px;
    margin-left: 8px;
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////
  @media screen and (max-width: $breakpoint-sm){
    .sidebar-header {
      background: var(--text-main-color);
      height: 45px;
      text-align: left;
      display: flex;
      align-items: center;
      padding-left: 18px;
    }
    .header__logo {
      margin: 0 auto 0 16px;
    }

    .header__navbar {
      display: block;
      text-align: left;
      font-size: 2rem;
    }

    .header__dropdown {
      margin: 0 20px 0 30px;
      color: var(--text-main-color);
    }

    .navbar__item {
      color: var(--text-seccond-color);
      font-size: 20px;
      padding: 0;
    }

    .navbar-link {
      color: var(--text-seccond-color);
      text-decoration: none;
      padding: 8px 16px;
      display: flex;
      align-content: center;
    }

    .navbar-link_active {
      color: var(--text-main-color);
    }

    .navbar-button {
      color: #A9B1E2;
      padding: 8px 16px;
      background: var(--text-main-color);
      border: none;
      outline: none;
      &:active, &:focus {
        color: #FFFFFF;
      }
    }

    .link-icon {
      margin-right: 6px;
      margin-top: 6px;
      opacity: 0.6;
      width: 17px;
      height: 17px;
    }
    .material-design-icon.exchange-rate-icon {
      margin-top: 0;
      height: 20px;
      width: 20px;
    }
    .material-design-icon.exchange-rate-icon > .material-design-icon__svg {
      height: 20px;
      width: 20px;
    }
    .material-design-icon.archive-icon {
      margin: -2px 6px 0 -2px;
      height: 20px;
      width: 20px;
    }
    .material-design-icon.archive-icon > .material-design-icon__svg {
      height: 20px;
      width: 20px;
    }
    .exchange-rate_active {
      color: var(--text-main-color);
      opacity: 1;
    }
    .navbar-link_active .link-icon {
      opacity: 1;
    }
    .exchange-rate-button {
      background: transparent;
      padding: 8px 16px;
      border: none;
      outline: none;
      color: var(--text-seccond-color);
      &.active {
        color: var(--text-main-color);
      }
    }
    .burger-button {
      margin-right: 13px;
    }
    .show_translate {
      position: absolute;
      transform: translate3d(-20px, 37px, 0px);
      top: 0;
      left: 0;
      will-change: transform;
    }
    .chevron-icon_profile {
      font-size: 20px;
      margin-left: 8px;
      color: var(--text-main-color);
    }
  }
</style>
